import {invert} from 'lodash';
import React, {PropsWithChildren, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {ChainId, chainIdToNetworkName, switchNetwork} from '../../lib/chains';
import {selectProject} from '../../redux/selectors';
import {disconnect, selectWallet} from '../../redux/wallet.slice';
import {useAppDispatch, useAppSelector} from '../hooks';

const withSwitchNetwork =
  <T,>(Component: React.FC<T>) =>
  (props: PropsWithChildren<T>) => {
    const {projectId} = useParams<{projectId: string}>();
    const project = useAppSelector(selectProject(projectId));
    const {chainId} = useAppSelector(selectWallet);
    const dispatch = useAppDispatch();
    const [isRequestPending, setRequestPending] = useState(false);

    useEffect(() => {
      if (project && project.network && chainId) {
        if (chainIdToNetworkName[chainId] !== project.network && !isRequestPending) {
          console.log(chainIdToNetworkName[chainId], chainId, project.network);
          setRequestPending(true);
          const _chainId = invert(chainIdToNetworkName)[project.network];
          _chainId &&
            switchNetwork(+_chainId as ChainId)
              .then(res => {
                if (res !== null) {
                  dispatch(disconnect());
                  return;
                }
                window.location.reload();
                return;
              })
              .finally(() => {
                setRequestPending(false);
              });
        }
      }
    }, [chainId, dispatch, isRequestPending, project]);

    return <Component {...props} />;
  };

export default withSwitchNetwork;
